import type React from "react";
import { ReactComponent as Svg } from "./assets/common-file-upload.svg";
import * as styles from "./Icon.module.scss";

type UploadProps = React.SVGProps<SVGSVGElement>;

export const Upload = ({ className, ...props }: UploadProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
